import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

export interface Translations {
  [translationKey: string]: string | Translations | null;
}

export class TranslateHttpLoader implements TranslateLoader {
  constructor(
    private httpClient: HttpClient,
    private prefix: string = '/assets/i18n/',
    private suffix: string = '.json'
  ) {}

  public getTranslation(lang: string): any {
    return this.httpClient
      .get<Translations>(`${this.prefix}${lang}${this.suffix}`)
      .pipe(map((res) => this.process(res)));
  }

  private process(translations: Translations): Translations {
    return Object.keys(translations)
      .filter(
        (key) => translations.hasOwnProperty(key) && translations[key] !== ''
      )
      .reduce(
        (result: Translations, key) => (
          (result[key] =
            typeof translations[key] === 'object'
              ? this.process(translations[key] as Translations)
              : translations[key]),
          result
        ),
        {}
      );
  }
}
